"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var assets_helper_1 = require("../../utils/assets.helper");

function getPlatformResizeMode(platformResizeMode) {
  if (platformResizeMode) {
    return react_native_1.Platform.select(platformResizeMode);
  }

  return undefined;
}

exports.ImageAsset = function (props) {
  var source = assets_helper_1.getResolvedImageSource(props.name) || -1;
  var resizeMode = getPlatformResizeMode(props.platformResizeMode);
  return react_1.default.createElement(react_native_1.Image, __assign({
    resizeMode: resizeMode
  }, props, {
    source: source
  }));
};